import PropTypes from 'prop-types';
import React from 'react';
import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

import { Delete } from '@material-ui/icons';
import { Colors } from '../../../../constants';
import { Mask } from '../../../../utils';

const Container = styled.div`
  display: flex;
  padding: 8px 16px;

  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0px 4px 4.8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;

  > span {
    color: rgba(0, 0, 0, 0.54);
    font-size: 14px;
  }
`;

const Title = styled.div`
  font-size: 16px;
  color: #000;
  font-weight: 400;
`;

const ActionButtonContainer = styled.div``;

const TagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 4px 0;
`;

const Tag = styled.div`
  border: 1px solid ${Colors.GRAY};
  border-radius: 16px;
  padding: 4px 8px;
  color: ${Colors.GRAY_DARKER};
  font-size: 14px;
  margin: 4px 4px 4px 0;
`;

function SelectedAgentRow({
  title,
  city,
  uf,
  tags,
  taxNumber,
  customerCode,
  handleRemove,
  ...props
}) {
  return (
    <Container {...props}>
      <TitleWrapper>
        <span>{Mask.cpfCnpj(taxNumber) || ''}</span>
        <Title>{title}</Title>
        <span>{customerCode || ''}</span>
      </TitleWrapper>
      {tags.length > 0 && (
        <TagsWrapper>
          {tags.map((item) => (
            <Tag
              key={`${item.name}-${item.id}`}
            >
              {item.name}
            </Tag>
          ))}
        </TagsWrapper>
      )}
      <ActionButtonContainer>
        {handleRemove ? (
          <IconButton
            color="primary"
            aria-label="Remover representante"
            onClick={handleRemove}
          >
            <Delete />
          </IconButton>
        ) : null}
      </ActionButtonContainer>
    </Container>
  );
}

SelectedAgentRow.propTypes = {
  handleRemove: PropTypes.func,
  title: PropTypes.string,
  city: PropTypes.string,
  uf: PropTypes.string,
  tags: PropTypes.array,
};

SelectedAgentRow.defaultProps = {
  handleRemove: null,
  title: '',
  city: '',
  uf: '',
  tags: [],
};

export default SelectedAgentRow;
